var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit, QueryList, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { AdminSocketService } from '../../../../services/admin.socket.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { EditorChoiceStore, InfoStore, ToggleStore } from '../../../../stores/hub.calendar.store';
import { VisitorSettingsStore } from '../../../../stores/visitor.calendar.store';
import { removeHtmlTags } from '../../../../utils/removeHtmlTags';
import { EditEventModalComponent } from '../../edit.event.modal/edit.event.modal.component';
import { EditEventModalActions } from '../../edit.event.modal/edit.event.modal.provider';
import { ShowMoreEventTimesModalComponent } from '../../../../common/components/show.more.event.times.modal/show.more.event.times.modal.component';
import { ShowMoreEventTimesModalActions, ShowMoreEventTimesModalData, } from '../../../../common/components/show.more.event.times.modal/show.more.event.times.modal.provider';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { AuthService } from '../../../../common/services/auth.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { ShowInfoModalComponent } from '../../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions, } from '../../show.info.modal/show.info.modal.provider';
import { HubCalendarComponent } from '../hub.calendar.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { isNullOrUndefined } from '../../../../common/extensions';
import { AIEventClassificationModalComponent } from '../../ai.event.classification.modal/ai.event.classification.modal.component';
import { AIEventClassificationModalActions, AIEventClassificationModalData, } from '../../ai.event.classification.modal/ai.event.classification.modal.provider';
import { ShowPromptModalComponent } from '../../show.prompt.modal/show.prompt.modal.component';
import { PromptModalData, ShowPromptModalActions, } from '../../show.prompt.modal/show.prompt.modal.provider';
import { AlertifyService } from '../../../../services/alertify.service';
var HubEventCardComponent = /** @class */ (function (_super) {
    __extends(HubEventCardComponent, _super);
    function HubEventCardComponent(router, activatedRoute, modalService, authService, hubApiService, imageService, socketService, infoStore, editorChoiceStore, visitorSettingsCommand, togglesStore, alertify, parent) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.socketService = socketService;
        _this.infoStore = infoStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.visitorSettingsCommand = visitorSettingsCommand;
        _this.togglesStore = togglesStore;
        _this.alertify = alertify;
        _this.parent = parent;
        _this.isUpdating = false;
        _this.editorChoiceText = '';
        _this.addToEditorChoiceTextTip = 'Add to ';
        _this.removeFromEditorChoiceTextTip = 'Remove from ';
        _this.toggles = new HubVisitorFeatureToggle();
        return _this;
    }
    HubEventCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.processDescription();
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            _this.addToEditorChoiceTextTip += _this.editorChoiceText;
            _this.removeFromEditorChoiceTextTip += _this.editorChoiceText;
        });
        this.visitorSettingsCommand.settingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (settings) {
            _this.customSettings = settings;
        });
        this.togglesStore.toggleCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            _this.toggles =
                isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.placeCalendar)
                    ? new HubVisitorFeatureToggle()
                    : toggleCommand;
        });
    };
    HubEventCardComponent.prototype.jumpToFacebook = function () {
        if (this.event.eventLink) {
            window.open(this.event.eventLink.startsWith('http')
                ? this.event.eventLink
                : "https://" + this.event.eventLink);
        }
        else if (this.event.socialName == 'eventbrite') {
            window.open('https://www.eventbrite.com/e/' + this.event.id);
        }
        else if (this.event.socialName == 'facebook') {
            window.open('https://www.facebook.com/' + this.event.id);
        }
        else if (this.event.socialName == 'eventful') {
            window.open('http://auckland.eventful.com/events/' + this.event.id);
        }
    };
    HubEventCardComponent.prototype.jumpToTicket = function ($event) {
        $event.stopPropagation();
        window.open(this.event.ticketUri
            ? this.event.ticketUri.startsWith('http')
                ? this.event.ticketUri
                : "https://" + this.event.ticketUri
            : '');
    };
    HubEventCardComponent.prototype.approve = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .approveEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isApproved = true;
        });
    };
    HubEventCardComponent.prototype.unApprove = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unApproveEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isApproved = false;
        });
    };
    HubEventCardComponent.prototype.pin = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .pinEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.parent.pinEvent(_this.event);
        });
    };
    HubEventCardComponent.prototype.unPin = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unPinEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.parent.unPinEvent(_this.event);
        });
    };
    HubEventCardComponent.prototype.choice = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .choiceEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isChoice = true;
        });
    };
    HubEventCardComponent.prototype.custom = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .customEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isCustom = true;
        });
    };
    HubEventCardComponent.prototype.unChoice = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unChoiceEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isChoice = false;
        });
    };
    HubEventCardComponent.prototype.unCustom = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unCustomEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isCustom = false;
        });
    };
    HubEventCardComponent.prototype.toBeExport = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .toBeExportEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isToBeExport = true;
        });
    };
    HubEventCardComponent.prototype.unToBeExport = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unToBeExportEvent(this.hubName, this.event._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.event.isToBeExport = false;
        });
    };
    HubEventCardComponent.prototype.showEditModal = function () {
        var _this = this;
        var actions = {
            confirm: function (event, e, image) {
                _this.event = e;
                _this.event.cover = {
                    source: null,
                    isDefault: false,
                    isLarge: _this.event.cover.isLarge,
                };
                _this.event.cover.source = _this.imageService.imageSourceUrl(image || null);
                _this.processDescription();
            },
        };
        this.event.hubName = this.hubName;
        this.modalService.show({
            component: EditEventModalComponent,
            providers: [
                { provide: EditEventModalActions, useValue: actions },
                { provide: HubEvent, useValue: this.event },
            ],
            panelClass: ['width-modal-4', 'ig-edit-event-modal', 'transition-50'],
        });
    };
    HubEventCardComponent.prototype.lock = function (event) {
        var _this = this;
        this.hubApiService
            .lock(this.hubName, this.event._id)
            .finally(event.complete)
            .subscribe(function () {
            _this.event.isLocked = true;
        });
    };
    HubEventCardComponent.prototype.unlock = function (event) {
        var _this = this;
        this.hubApiService
            .unlock(this.hubName, this.event._id)
            .finally(event.complete)
            .subscribe(function () {
            _this.event.isLocked = false;
        });
    };
    /** logic delete */
    HubEventCardComponent.prototype.remove = function () {
        var _this = this;
        if (this.event.isManuallyCreated) {
            this.deletePermanently();
            return;
        }
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .removeEvent(_this.hubName, _this.event._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.parent.removeEvent(_this.event, false);
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            // confirmModalDescription: 'Are you sure you want to block this event, all events belong to this organizer will be blocked too?',
            confirmModalDescription: 'Are you sure you want to delete this event?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    HubEventCardComponent.prototype.block = function () {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .block(_this.hubName, _this.event._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.parent.removeEvent(_this.event);
                    var doNotShowModal = localStorage.getItem(localStorageKeys.doNotShowRemoveSuccessfullyModal);
                    if (!doNotShowModal) {
                        _this.showRmoveSuccessModal();
                    }
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this event?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    /**
     * remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull
     * */
    HubEventCardComponent.prototype.deletePermanently = function () {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteEvent(_this.hubName, _this.event._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.parent.removeEvent(_this.event);
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this event permanently, this operation cannot be reverted.',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    HubEventCardComponent.prototype.showMoreTimes = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        var actions = {
            confirm: function () { },
        };
        var data = {
            title: this.event.title,
            eventTimes: this.event.eventTimes,
            eventTimesText: this.event.eventTimesText,
            timezone: this.event.timezone,
            isManualTime: !!this.event.startTimeText,
        };
        this.modalService.show({
            component: ShowMoreEventTimesModalComponent,
            providers: [
                { provide: ShowMoreEventTimesModalActions, useValue: actions },
                { provide: ShowMoreEventTimesModalData, useValue: data },
            ],
        });
    };
    HubEventCardComponent.prototype.addOrRemoveToCustomBtn = function (btn, index) {
        var _this = this;
        if (!this.isInCustomBtn(btn)) {
            this.hubApiService
                .addEventToCustomBtn(this.hubName, this.event._id, index)
                .subscribe(function (customEvents) {
                _this.parent.customBtns.events = customEvents;
            });
        }
        else {
            this.hubApiService
                .removeEventFromCustomBtn(this.hubName, this.event._id, index)
                .subscribe(function (customEvents) {
                _this.parent.customBtns.events = customEvents;
            });
        }
    };
    HubEventCardComponent.prototype.addOrRemoveFromTour = function (tour) {
        var _this = this;
        if (!this.isInTour(tour)) {
            this.hubApiService
                .addAttractionToTour(this.hubName, {
                id: tour._id,
                feedType: 'event',
                feedId: this.event._id,
            })
                .subscribe(function () {
                var currentTour = _this.parent.tours.find(function (x) { return x._id === tour._id; });
                if (currentTour) {
                    currentTour.days[0].attractions.push({
                        feedId: _this.event._id,
                        feedType: 'event',
                    });
                }
                // this.hubApiService.getTours(this.hubName)
                //   .subscribe((tours) => {
                //     this.parent.tours = tours;
                //   });
            });
        }
        else {
            this.hubApiService
                .removeAttractionFromTour(this.hubName, {
                id: tour._id,
                attractionId: this.event._id,
                feedType: 'event',
            })
                .subscribe(function () {
                // this.hubApiService.getTours(this.hubName)
                //   .subscribe((tours) => {
                //     this.parent.tours = tours;
                //   });
                var currentTour = _this.parent.tours.find(function (x) { return x._id === tour._id; });
                if (currentTour) {
                    currentTour.days.forEach(function (day) {
                        day.attractions = day.attractions.filter(function (x) { return x.feedId !== _this.event._id; });
                    });
                }
            });
        }
    };
    HubEventCardComponent.prototype.gotoTours = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.tours, {
                            hubName: this.hubName,
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubEventCardComponent.prototype.isInTour = function (tour) {
        var _this = this;
        if (tour) {
            return tour.days.some(function (x) { return x.attractions.some(function (x) { return x.feedId === _this.event._id; }); });
        }
        else {
            if (!this.parent.tours) {
                return false;
            }
            return this.parent.tours.some(function (tour) {
                return tour.days.some(function (day) {
                    return day.attractions.some(function (attraction) {
                        return attraction.feedId === _this.event._id;
                    });
                });
            });
        }
    };
    HubEventCardComponent.prototype.isInCustomBtn = function (btn) {
        var _this = this;
        if (btn) {
            return btn.events.any(function (x) { return x === _this.event._id; });
        }
        else {
            var isIn = false;
            if (this.parent.customBtns.events) {
                for (var _i = 0, _a = this.parent.customBtns.events; _i < _a.length; _i++) {
                    var x = _a[_i];
                    if (x.events.any(function (x) { return x === _this.event._id; })) {
                        isIn = true;
                        break;
                    }
                }
            }
            return isIn;
        }
    };
    HubEventCardComponent.prototype.aiCategory = function () {
        this.modalService.show({
            component: AIEventClassificationModalComponent,
            providers: [
                { provide: AIEventClassificationModalActions, useValue: null },
                {
                    provide: AIEventClassificationModalData,
                    useValue: { hubName: this.hubName },
                },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    HubEventCardComponent.prototype.updateEvent = function ($event) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
        }
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Update Event', null, [
                        'Start updating Facebook event, please read the status on the console tab.',
                    ]),
                },
            ],
            panelClass: 'width-modal-2',
        });
        if (this.event.socialName === 'facebook|spider') {
            if (this.event.eventLink) {
                // this.openSocket(mpdal);
                this.hubApiService
                    .updateFBSpiderEvent(this.hubName, this.event.eventLink)
                    .subscribe(function (result) {
                    console.log(JSON.stringify(result));
                    if (!result.error) {
                        _this.event.name = _this.event.title = result.data.title;
                        _this.event.hostLink = result.data.host.hostLink;
                        _this.event.owner.name = result.data.host.hostName;
                        _this.event.cover.source = result.data.img.imgUrl;
                        _this.event.description = result.data.description;
                        _this.event.address = result.data.address;
                        _this.event.ticketUri = result.data.ticketUrl;
                        _this.event.eventTimes = result.data.time.eventTimes;
                        _this.event.startTime = result.data.time.startTime;
                        _this.event.endTime = result.data.time.endTime;
                        _this.event.timezone = result.data.time.timezone;
                        _this.processDescription();
                        EventTimeService.processEventTime(_this.event);
                        console.log("update finished successfully");
                    }
                    else {
                        _this.infoStore.infoCommand.next(result.msg);
                        console.log('update error :', result.msg);
                    }
                    // this.closeSocket();
                });
            }
            else {
                this.infoStore.infoCommand.next("<span style=\"color:red\">This event hasn't a link, please check.</span>");
                console.log("This event hasn't a link, please check.");
            }
        }
        else {
            this.infoStore.infoCommand.next("<span style=\"color:red\">This is not a Facebook event, please check.</span>");
            console.log("This is not a Facebook event, please check");
        }
    };
    HubEventCardComponent.prototype.processDescription = function () {
        if (!this.event.description || this.event.description === 'undefined') {
            this.descriptionText = '(no description)';
        }
        else {
            var text = removeHtmlTags(this.event.description);
            if (text.length > 150) {
                this.descriptionText = text.substr(0, 150).concat('...');
            }
            else {
                this.descriptionText = text;
            }
        }
    };
    HubEventCardComponent.prototype.openSocket = function (modal) {
        var _this = this;
        this.socketService.init();
        this.socketService.socket.on('scheduler-status', function (isRunning) { return (_this.isSchedulerRunning = isRunning); });
        this.socketService.socket.on('scheduler-progress', function (report) {
            console.log(report.message);
            if (report.message) {
                if (report.message.toLowerCase().indexOf('pulling program is still running') >= 0) {
                    modal.close();
                    return;
                }
            }
            if (report.message && report.message.indexOf(': ') >= 0) {
                var messageSeg = report.message.split(': ');
                report.message = "<strong>" + messageSeg[0] + ":</strong> " + messageSeg[1];
            }
            if (report.color) {
                report.message =
                    report.color === 'green'
                        ? report.message + " You can close this window now."
                        : report.message;
                report.message = "<span style=\"color:" + report.color + "\">" + report.message + "</span>";
            }
            _this.infoStore.infoCommand.next(report.message);
        });
    };
    HubEventCardComponent.prototype.closeSocket = function () {
        this.socketService.socket.off('scheduler-status');
        this.socketService.socket.off('scheduler-progress');
        this.socketService.close();
    };
    HubEventCardComponent.prototype.showRmoveSuccessModal = function () {
        this.modalService.show({
            component: ShowPromptModalComponent,
            providers: [
                { provide: ShowPromptModalActions, useValue: null },
                {
                    provide: PromptModalData,
                    useValue: new PromptModalData('Remove successfully', null, [
                        'The selected item has been successfully removed from the dashboard.',
                        'You can restore this item from the Removed List at any time.',
                        'While in the Removed List, this item cannot be pulled again.',
                    ]),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    HubEventCardComponent.prototype.enlargeImage = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if ($event) {
                    $event.stopPropagation();
                }
                if (this.isOperating)
                    return [2 /*return*/];
                this.isOperating = true;
                this.hubApiService
                    .resizeImageFromUnApprovedEvent(this.hubName, this.event._id)
                    .finally(function () {
                    _this.isOperating = false;
                })
                    .subscribe(function (result) {
                    if (result.success) {
                        _this.event.cover = {
                            source: result.url,
                            isLarge: true,
                        };
                    }
                    else {
                        _this.alertify.error('Something went wrong, please try again.', 3);
                    }
                }, function (error) {
                    console.error('Error enlarging image', error);
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(HubEventCardComponent.prototype, "shouldShowEnlargeImage", {
        get: function () {
            if (!this.event ||
                !this.event.socialName ||
                !this.event.cover ||
                !this.event.cover.source ||
                this.event.cover.isLarge) {
                return false;
            }
            // only show the enlarge image for newly pulled events
            return (this.event.socialName.includes('serp|google') &&
                !this.event.cover.isLarge &&
                new Date(this.event.createdAt).getTime() > new Date('2025-02-26').getTime());
        },
        enumerable: true,
        configurable: true
    });
    return HubEventCardComponent;
}(BaseComponent));
export { HubEventCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/event.card/hub.event.card.component.ts.pre-build-optimizer.js